import { breakingList } from "@/mocks/melon";

const badgeColor: Record<string, string> = {
  追踪中: "bg-primary-500 text-background-50",
  新进展: "bg-accent-500 text-foreground-950",
  已收尾: "bg-secondary-500 text-background-50",
};
const dotColor: Record<string, string> = {
  追踪中: "ri-time-line",
  新进展: "ri-flashlight-fill",
  已收尾: "ri-checkbox-circle-line",
};

export default function Breaking() {
  return (
    <section id="breaking" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="mb-2 text-xs font-bold tracking-widest text-primary-500">LIVE &amp; FOLLOW</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">突发大事</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              正在发生、值得跟进的事件都在这里，我们会持续更新进度直到事态脉络清晰。
            </p>
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {breakingList.map((b) => (
            <article key={b.title} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative aspect-[4/3] w-full overflow-hidden bg-background-100">
                <img
                  src={b.image}
                  alt={b.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${badgeColor[b.status]}`}>
                  <i className={`${dotColor[b.status]} text-sm`} aria-hidden="true" />
                  {b.status}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span className="rounded bg-background-100 px-1.5 py-0.5 text-foreground-500">{b.field}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" aria-hidden="true" />
                    {b.time}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                  {b.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{b.summary}</p>
                <a href="#review" className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700">
                  查看跟进
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}